import { render, staticRenderFns } from "./DataAccessEmptyState.vue?vue&type=template&id=14b0fa38&scoped=true&"
import script from "./DataAccessEmptyState.vue?vue&type=script&lang=js&"
export * from "./DataAccessEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessEmptyState.vue?vue&type=style&index=0&id=14b0fa38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0fa38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
